import { columnDefs } from "../app/modules/Contracts/PostDatedCheques/pdcColumn";
import { defaultColumns } from "../app/modules/Units/grid/columns";
import { gridSettings, saveGidSettings } from "../configs/constants";
import { GridType } from "../types/grid";
import axios from "./axiosInceptor";

const getScreenColumn = (screenName) => {
  if (screenName === "payment") {
    return columnDefs;
  } else if (screenName === "units") {
    return defaultColumns;
  }
};

const mergeSavedWithDefaultColumns = (savedColumns: GridType[] = [], defaultColumns: GridType[] = []) => {
  if (!Array.isArray(savedColumns) || savedColumns.length === 0) return defaultColumns;
  if (!Array.isArray(defaultColumns) || defaultColumns.length === 0) return savedColumns;

  const savedKeyMap = new Map(savedColumns.map((column) => [String(column?.field ?? column?.id ?? ""), true]));

  const newColumns = defaultColumns.filter((column) => !savedKeyMap.has(String(column?.field ?? column?.id ?? "")));

  // Keep user-defined order/visibility first, then append newly introduced columns.
  return [...savedColumns, ...newColumns];
};

export const saveGridSettings = async (screenName, gridSettings: GridType[] | null = null, directPost = false) => {
  try {
    if (!screenName && !gridSettings && !directPost) return false;
    let payload = { screen: screenName };

    payload["settings"] = gridSettings;
    let response = await axios.post(`${saveGidSettings}`, payload);

    return response?.data?.result ? response?.data?.result?.settings : [];
  } catch (error) {
    console.log(error);
  }
};

export const getGridSettings = async (screenName, column: GridType[] | null = null, directPost = false) => {
  try {
    const gridConfig = await axios.get(`${gridSettings}${screenName}`);
    const defaultColumns = column ?? getScreenColumn(screenName);

    if (!gridConfig?.data?.result) {
      let data = await saveGridSettings(screenName, defaultColumns, true);
      return data;
    } else if (screenName && column && directPost) {
      let data = await saveGridSettings(screenName, column, directPost);
      return data;
    } else if (!directPost) {
      const savedColumns = gridConfig?.data?.result?.settings ?? [];
      return mergeSavedWithDefaultColumns(savedColumns, defaultColumns ?? []);
    }
  } catch (erro) {
    console.log(erro);
  }
};
